export = ['Legacy Application Decodes', 'Application Decodes'];
